import MultiSelectBottomContentsCode from "!!raw-loader!./autocomplete/MultiSelectBottomContents.tsx";
import MultiSelectDisabledCode from "!!raw-loader!./autocomplete/MultiSelectDisabled.tsx";
import MultiSelectFullWidthCode from "!!raw-loader!./autocomplete/MultiSelectFullWidth.tsx";
import MultiSelectGroupingCode from "!!raw-loader!./autocomplete/MultiSelectGrouping.tsx";
import MultiSelectLimitCode from "!!raw-loader!./autocomplete/MultiSelectLimit.tsx";
import MultiSelectNoChipsCode from "!!raw-loader!./autocomplete/MultiSelectNoChips.tsx";
import MultiSelectCustomOptionsCode from "!!raw-loader!./autocomplete/MultiSelectCustomOptions.tsx";
import MultiSelectOnChangeCode from "!!raw-loader!./autocomplete/MultiSelectOnChange.tsx";
import MultiSelectOverflowCode from "!!raw-loader!./autocomplete/MultiSelectOverflow.tsx";
import MultiSelectPlaceholderCode from "!!raw-loader!./autocomplete/MultiSelectPlaceholder.tsx";
import MultiSelectInvalidCode from "!!raw-loader!./autocomplete/MultiSelectInvalid.tsx";
import MultiSelectSlimCardCode from "!!raw-loader!./autocomplete/MultiSelectSlimCard.tsx";
import MultiSelectReactWindowCode from "!!raw-loader!./autocomplete/MultiSelectReactWindow.tsx";
import MultiSelectPinyinFilteringCode from "!!raw-loader!./autocomplete/MultiSelectPinyinFiltering.tsx";
import MultiSelectSelectAllCode from "!!raw-loader!./autocomplete/MultiSelectSelectAll.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import MultiSelectFullWidth from "./autocomplete/MultiSelectFullWidth";
import MultiSelectLimit from "./autocomplete/MultiSelectLimit";
import MultiSelectOnChange from "./autocomplete/MultiSelectOnChange";
import MultiSelectOverflow from "./autocomplete/MultiSelectOverflow";
import MultiSelectPlaceholder from "./autocomplete/MultiSelectPlaceholder";
import MultiSelectNoChips from "./autocomplete/MultiSelectNoChips";
import MultiSelectGrouping from "./autocomplete/MultiSelectGrouping";
import MultiSelectDisabled from "./autocomplete/MultiSelectDisabled";
import MultiSelectInvalid from "./autocomplete/MultiSelectInvalid";
import MultiSelectCustomOptions from "./autocomplete/MultiSelectCustomOptions";
import MultiSelectBottomContents from "./autocomplete/MultiSelectBottomContents";
import MultiSelectSlimCard from "./autocomplete/MultiSelectSlimCard";
import MultiSelectReactWindow from "./autocomplete/MultiSelectReactWindow";
import MultiSelectPinyinFiltering from "./autocomplete/MultiSelectPinyinFiltering";
import MultiSelectSelectAll from "./autocomplete/MultiSelectSelectAll";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("ReactWindow", MultiSelectReactWindowCode, MultiSelectReactWindow, "Use React Window render options"),
		paneComponent("SlimCard", MultiSelectSlimCardCode, MultiSelectSlimCard, "Use Slim Card to render options"),
		paneComponent("FullWidth", MultiSelectFullWidthCode, MultiSelectFullWidth, "It would take up the full width of the parent by default, specify the width to change this behavior"),
		paneComponent("SelectAll", MultiSelectSelectAllCode, MultiSelectSelectAll, "Add Select All item and functionality"),
		paneComponent("Overflow", MultiSelectOverflowCode, MultiSelectOverflow),
		paneComponent("Limit", MultiSelectLimitCode, MultiSelectLimit),
		paneComponent("No Chips", MultiSelectNoChipsCode, MultiSelectNoChips),
		paneComponent("Placeholder", MultiSelectPlaceholderCode, MultiSelectPlaceholder),
		paneComponent("OnChange Callback", MultiSelectOnChangeCode, MultiSelectOnChange, "Callback - onChange would happen either clear/delete the value or close the drop-down, but not check/uncheck the values in the drop-down"),
		paneComponent("Custom options", MultiSelectCustomOptionsCode, MultiSelectCustomOptions),
		paneComponent("Grouping", MultiSelectGroupingCode, MultiSelectGrouping),
		paneComponent("Actions menu", MultiSelectBottomContentsCode, MultiSelectBottomContents),
		paneComponent("Disabled Items", MultiSelectDisabledCode, MultiSelectDisabled),
		paneComponent("Invalid Items", MultiSelectInvalidCode, MultiSelectInvalid),
		paneComponent("Pinyin Filtering", MultiSelectPinyinFilteringCode, MultiSelectPinyinFiltering, "Use Pinyin code to filter out items"),
	];

	return (
		<Pane
			components={components}
			imports={"import {MultiSelect} from \"designSystem/index\";"}
			muiApi="autocomplete"
			muiComponent="autocomplete"
			{...props}
		/>
	);
};